export const companyPickerResult = (change: any): string | null => {
    if (change.op === 'add') {
        return change.value.key;
    }

    return null;
}